import React from 'react';
import util from "../../util/tools";
import commonTools from "../../../common/util/util";
import {goRoute} from '../common/js'
import Img from 'react-image'
import P from "prop-types";
import { Link } from "react-router-dom";
import { Carousel, WingBlank } from 'antd-mobile';
import './index.css';
import {isTest} from "../../../config";
import IndexBottom from "../common/IndexBottom/IndexBottom";

import Activity from '../common/activity'

export default class Home extends React.Component {
    static propTypes = {
        location: P.any,
        history: P.any,
        actions: P.any
    };

    constructor(props) {
        super(props);
        // 2020.05.01 00:00:00~2020.05.05 23:59:59

        this.state = {
            curTitle: "首页",
            currentNav:137,
            imgs: [],
            data1:[],
            data2:[],
            data3:[],
            dailyBook:[],
            historyData:{},
            qingmingStart: false,//清明节活动是否开始 默认未开始
            duanwuStart: false,//端午活动是否开始 默认未开始
            wuyiStart: false,//五一节活动是否开始 默认未开始
            zhongqiuStart:false,//中秋节活动是否开始 默认未开始
            doubleOneStart:false,//双11活动是否开始 默认未开始
            customImgsLink:undefined,//自定义图片链接
            yuandanStart: false, //元旦活动是否开始 默认未开始
            newYearStart: false, //春节节活动是否开始 默认未开始
            activeData: {
                img_url: "",
                link_url: ""
            }
        };

        this.unLock = this.unLock.bind(this);
        this.getImgsFun = this.getImgsFun.bind(this);
        this.goRoute = this.goRoute.bind(this);
    }

    goRoute(url){
        this.props.history.push(url)
    }
    getActiveInfo(){
        util.ajax({
            url: "/zh/additional/acitve",
            data:{
                only_home: 1
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    console.log('活动数据',json);
                    this.setState({activeData: json})
                }
            }
        });
    }

    componentDidMount() {
        document.title = this.state.curTitle;
        this.getData(136)
        let currentNav = 137;//男频
        if(commonTools.cnzzData.property == 2){
            currentNav = 138;//女频
        }
        this.setState({
            currentNav: currentNav
        },()=>{
            this.getData(this.state.currentNav);
            this.getImgsFun();
        });
        this.tuijianData();
        this.dailyData();
        this.historyData();
        this.getActiveInfo();
        

        let minTime = new Date("2019/04/05 00:00:00").getTime();
        let maxTime = new Date("2019/04/15 00:00:00").getTime();
        let curTime = new Date().getTime();
        if((curTime >= minTime && curTime <= maxTime) || !!commonTools.searchPar().qingmingStart){
            this.setState({
                qingmingStart: true
            });
        }

        let minTime1 = new Date("2019/04/27 00:00:00").getTime();
        let maxTime1 = new Date("2019/05/06 00:00:00").getTime();
        if((curTime >= minTime1 && curTime <= maxTime1) || !!commonTools.searchPar().wuyiStart){
            this.setState({
                wuyiStart: true
            });
        }

        let minTime2 = new Date("2019/06/05 00:00:00").getTime();
        let maxTime2 = new Date("2019/06/17 00:00:00").getTime();
        if((curTime >= minTime2 && curTime <= maxTime2) || !!commonTools.searchPar().duanwuStart){
            this.setState({
                duanwuStart: true
            });
        }
        let minTime3 = new Date("2019/09/13 00:00:00").getTime();
        let maxTime3 = new Date("2019/09/14 00:00:00").getTime();
        if((curTime >= minTime3 && curTime <= maxTime3) || !!commonTools.searchPar().zhongqiuStart){
            this.setState({
                zhongqiuStart: true
            });
        }

        let minTime4 = new Date("2019/11/11 00:00:00").getTime();
        let maxTime4 = new Date("2019/11/14 00:00:00").getTime();
        if((curTime >= minTime4 && curTime <= maxTime4) || !!commonTools.searchPar().doubleOneStart){
            this.setState({
                doubleOneStart: true
            });
        }

        let minTime5 = new Date("2019/12/31 19:00:00").getTime();
        let maxTime5 = new Date("2020/01/4 23:59:00").getTime();
        if((curTime >= minTime5 && curTime <= maxTime5) || !!commonTools.searchPar().yuandanStart){
            this.setState({
                yuandanStart: true
            });
        }

        let minTime6 = new Date("2019/09/13 00:00:00").getTime();
        let maxTime6 = new Date("2019/09/14 00:00:00").getTime();
        if((curTime >= minTime6 && curTime <= maxTime6) || !!commonTools.searchPar().newYearStart){
            this.setState({
                newYearStart: true
            });
        }
        //zhongqiuStart
        this.getImg()
    }

    getImgsFun(){
        util.ajax({
            url: "/zh/active/lists",
            data:{
                wechat_id:util.wechat_id,//以后封装到ajax里面
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    this.setState({imgs: json})
                }
            }
        });
    }

    //活动跳转
    getImg(){
        util.ajax({
            url: "/zh/additional/acitve",
            isUser: true,
            isWechatId: true,
            data: {

            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    //url link
                    this.setState({
                        customImgsLink:json
                    })
                }
            }
        });
    }

    getData(type){
        util.ajax({
            url: "/zh/book/ranking",
            isUser: true,
            isWechatId: true,
            data: {
                num: 10,
                page:1,
                re_cid:type
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    let tempObj = {};
                    switch (type){
                        case 136:
                            tempObj.data1 = json;
                            break;
                        default:
                            tempObj.data2 = json;
                    }
                    this.setState(tempObj)
                }
            }
        });
    }
    // 阅文推荐
    tuijianData(type){
        util.ajax({
            url: "/zh/book/yuewenlists",
            data: {
                num: 4,
                page:1,
                yw_re_cid:136
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    let tempObj = {};
                    tempObj.data3 = json;
                    this.setState(tempObj)
                }
            }
        });
    }

    // 每日全本购
    dailyData(type){
        util.ajax({
            url: "/zh/allbookbuy/lists",
            data: {
                num: 4,
                page:1,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let json = res.result.data;
                    let tempObj = {};
                    tempObj.dailyBook = json;
                    this.setState(tempObj)
                }
            }
        });
    }

    changeData(index){
        this.setState({
            currentNav: index
        },()=>{
            this.getData(index)
        })
    }

    historyData(){
        util.ajax({
            url:"/zh/user/lastRead",
            isUser: true,
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data
                    if(data.length > 0){
                        this.setState({
                            historyData: data[0]
                        })
                    }
                }
            }
        });
    }

    LinkTo(link){
        this.props.history.push(`${link}`)
    }

    unLock(props,bookId,lockContentId){
        util.ajax({
            url: "/zh/additional/randomstr",
            isUser: true,
            isWechatId: true,
            method: "post",
            callback: res => {
                if (res.result.status.code == 0) {
                    let random_str = res.result.data.random_str;
                    document.location.href = `https://m.weidaoip.com/youhe/book/content/${bookId}/${lockContentId}?source=${document.location.host}&user_token=${util.user_token}&random_str=${random_str}`;
                }
            }
        });
    }

    render() {
        return (
            <div className='home' data-home="2">
                {
                    !!this.state.yuandanStart &&
                    <Link to='/activeFirstDayForYear?from=1'><img className="czhd" src={require("../../../common/images/yuandanmin.jpg")} /></Link>
                }
                {/*活动*/}
                {
                    this.state.activeData.img_url &&
                    <Link to={this.state.activeData.link_url + '?from=1'}><img className="czhd" src={this.state.activeData.img_url} /></Link>
                }
                {
                    this.state.imgs.length > 0 &&
                    <div className='bannerBox'>
                        <WingBlank style={{margin:0}}>
                            <Carousel
                                selectedIndex={0}
                                dots={false}
                                autoplay={true}
                                autoplayInterval={2000}
                                infinite={true}
                            >
                                {
                                    this.state.imgs.map((item,index) => (
                                        <img className={`imgBlock`} onClick={()=>this.goRoute(item.active_url)} src={item.active_img_url} key={`bannerimg${index}`} />
                                    ))
                                }
                            </Carousel>
                        </WingBlank>
                    </div>
                }
                <div className='home_series'>
                    <Link to='search' className='home_series_single a_s'>搜索</Link>
                    <Link to='mine' className='home_series_single a_g'>个人中心</Link>
                    <Link to='recharge' className='home_series_single a_c'>充值</Link>
                    <Link to='recentlyread' className='home_series_single a_y'>阅读历史</Link>
                </div>
                {
                    !!this.state.qingmingStart &&
                    <Link to='/qingmingrecharge'><img className="czhd" src={require("../../../common/images/qingming1Bg.jpg")} /></Link>
                }
                {
                    !!this.state.wuyiStart &&
                    <Link to='/wuyirecharge'><img className="czhd" src={require("../../../common/images/wuyi1Bg.jpg")} /></Link>
                }

                {
                    !!this.state.duanwuStart &&
                    <Link to='/duanwurecharge'><img className="czhd" src={require("../../../common/images/duanwuBg1.jpg")} /></Link>
                }
                {
                    !!this.state.zhongqiuStart &&
                    <Link to='/minautumnrecharge'><img className="czhd" src={require("../../../common/images/midautumnbg.jpg")} /></Link>
                }
                {/*{*/}
                    {/*!!this.state.customImgsLink &&*/}
                    {/*(*/}
                        {/*this.state.customImgsLink.link_url!=="" ?*/}
                            {/*<a href={this.state.customImgsLink.link_url}><img className="czhd" src={this.state.customImgsLink.img_url} ></img></a> :*/}
                            {/*<img className="czhd" src={this.state.customImgsLink.img_url} ></img>*/}
                    {/*)*/}
                {/*}*/}

                <div className='home_classifyRank'>
                    <Link to='category' className='home_classifyRank_single'></Link>
                    <Link to='rank' className='home_classifyRank_single'></Link>
                </div>
                {/* 公共活动 */}
                <Activity location='index'></Activity>
                {
                    !!this.state.data1 && this.state.data1.length>0&&
                    <div className='booksThr'>
                        {
                            this.state.data1.map((item,index) => (
                                <div className='booksThr_single' key={`a_${index}`} onClick={()=>goRoute(this.props,item.book_id,0)}>
                                    <Img className='booksThr_single_pic' src={item.cover_url}/>
                                    <div className='booksThr_single_name text-overflow'>{item.book_title}</div>
                                    <div className='booksThr_single_author text-overflow'>{item.author_name}</div>
                                </div>
                            ))
                        }
                    </div>
                }
                <div style={{marginTop:"0.3rem"}}></div>
                {/*{*/}
                    {/*(*/}
                        {/*<div className='module1'>*/}
                            {/*<div className='title'>*/}
                                {/*<div className='title_line'></div>*/}
                                {/*<span className='title_font'>每日全本购</span>*/}
                            {/*</div>*/}
                            {/*{*/}
                                {/*(!!this.state.dailyBook && this.state.dailyBook.length>0) ?*/}
                                    {/*<div className='booksThr'>*/}
                                        {/*{*/}
                                            {/*this.state.dailyBook.map((item,index) => (*/}
                                                {/*<div className='booksThr_single' key={`a_${index}`} onClick={()=>goRoute(this.props,item.book_id,0)}>*/}
                                                    {/*<Img className='booksThr_single_pic' src={item.cover_url}/>*/}
                                                    {/*<div className='booksThr_single_name text-overflow'>{item.book_title}</div>*/}
                                                    {/*<div className='booksThr_single_author text-overflow' style={{position:"relative"}}>*/}
                                                        {/*<span style={{color:"red",fontSize:"0.28rem",lineHeight:"0.28rem"}}>{item.discount_price}</span>*/}
                                                        {/*<span style={{color:"red",fontSize:"0.14rem"}}>金币</span>*/}
                                                        {/*<span style={{*/}
                                                            {/*//贯穿线不居中*/}
                                                            {/*position:"absolute",*/}
                                                            {/*right:"0rem",*/}
                                                            {/*top:"-0.02rem",*/}
                                                            {/*display: "inline-block",*/}
                                                            {/*color: "#666",*/}
                                                            {/*fontSize: ".14rem",*/}
                                                            {/*backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAJEAAAAAAP///5mZmf///yH5BAEAAAMALAAAAAABAAEAAAICVAEAOw==)",*/}
                                                            {/*backgroundRepeat: "repeat-x",*/}
                                                            {/*backgroundPosition: "left center",*/}
                                                            {/*height:" .32rem",*/}
                                                            {/*lineHeight: ".32rem",*/}
                                                        {/*}}>*/}
                                                            {/*{item.original_price}金币*/}
                                                        {/*</span>*/}
                                                    {/*</div>*/}
                                                {/*</div>*/}
                                            {/*))*/}
                                        {/*}*/}
                                    {/*</div> : ""*/}
                            {/*}*/}
                        {/*</div>*/}
                    {/*)*/}
                {/*}*/}
                <div className='module1'>
                    <div className='title'>
                        <div className='title_line'></div>
                        <span className='title_font'>阅文推荐</span>
                    </div>

                    {
                        !!this.state.data3 && this.state.data3.length>0&&
                        <div className='bookOne clearfix' onClick={()=>this.unLock(this.props,this.state.data3[0].book_id,0)}>
                            <Img className='booksThr_single_pic' src={this.state.data3[0].img_url}/>
                            <div className='booksThr_single_name text-overflow'>{this.state.data3[0].book_name}</div>
                            <div className='booksThr_single_author text-overflow3'>{this.state.data3[0].book_intro}</div>
                        </div>
                    }
                    {
                        !!this.state.data3 && this.state.data3.length>0&&
                        <div className='booksThr'>
                            {
                                this.state.data3.map((item,index) => (
                                    !!index && <div className='booksThr_single' key={`a_${index}`} onClick={()=>this.unLock(this.props,item.book_id,0)}>
                                        <Img className='booksThr_single_pic' src={item.img_url}/>
                                        <div className='booksThr_single_name text-overflow'>{item.book_name}</div>
                                        <div className='booksThr_single_author text-overflow'>{item.author_name}</div>
                                    </div>
                                ))
                            }
                        </div>
                    }
                </div>

                <div className='module1'>
                    <div className='title'>
                        <div className='title_line'></div>
                        <span className='title_font'>排行</span>
                    </div>
                    <div className='tab'>
                        <div className={`tab_single ${this.state.currentNav==138 && 'tab_singleColor'}`} onClick={()=>this.changeData(138)}>女生</div>
                        <div className={`tab_single ${this.state.currentNav==137 && 'tab_singleColor'}`} onClick={()=>this.changeData(137)}>男生</div>
                        {/* <div className={`tab_single ${this.state.currentNav==139 && 'tab_singleColor'}`} onClick={()=>this.changeData(139)}>出版</div> */}
                    </div>
                    <div className='books1'>
                        <div className='books1_singleOut'>
                            {
                                !!this.state.data2 && this.state.data2.length>0 &&
                                this.state.data2.map((item,index) => (
                                    index < 3 &&
                                    <div className='books1_single' key={`b_${index}`} onClick={()=>goRoute(this.props,item.book_id,0,0)}>
                                        <Img className='books1_single_pic' src={item.cover_url}/>
                                        <div className='books1_single_name text-overflow'>{item.book_title}</div>
                                        <div className='books1_single_author text-overflow'>{item.author_name}</div>
                                        <div className='books1_single_rank'>{parseInt(index)+1}</div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className='books1_singleNextOut'>
                            {
                                !!this.state.data2 && this.state.data2.length>0 &&
                                this.state.data2.map((item,index) => (
                                    index>2 &&
                                    <div className='books1_singleNext' key={`c_${index}`} onClick={()=>goRoute(this.props,item.book_id,0,0)}>
                                        <span className='books1_singleNext_rank'>{index+1}.</span>
                                        <span className='books1_singleNext_type'>{!!item.category_info.category_1.short_name?item.category_info.category_1.short_name:"其他"}</span>
                                        <span className='books1_singleNext_name text-overflow'>{item.book_title}</span>
                                        <span className='books1_singleNext_author text-overflow'>{item.author_name}</span>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
                <Link to={`/rank?type=${this.state.currentNav}`} className='more'>更多</Link>
                {
                    !!this.state.historyData && this.state.historyData.book_id &&
                    <div className='lastTime' onClick={()=>goRoute(this.props,this.state.historyData.book_id,this.state.historyData.content_id,0)}>
                        <Img className='book' src={require('../../../common/images/book.png')} alt=""/>
                        <span className='font text-overflow'>请继续阅读《{this.state.historyData.book_title.length>6?this.state.historyData.book_title.substring(0,6)+'...':this.state.historyData.book_title}》，点击继续</span>
                        <Img className='arrow' src={require('../../../common/images/arrow_r.png')} alt=""/>
                    </div>
                }
                <IndexBottom/>
            </div>
        );
    }
}

// export default class Home extends React.Component {
//     static propTypes = {
//         location: P.any,
//         history: P.any,
//         actions: P.any
//     };
//
//     constructor(props) {
//         super(props);
//         this.state = {
//             curTitle: "首页",
//             currentNav:137,
//             imgs: [],
//             data1:[],
//             data2:[],
//             data3:[],
//             dailyBook:[],
//             historyData:{},
//             qingmingStart: false,//清明节活动是否开始 默认未开始
//             duanwuStart: false,//端午活动是否开始 默认未开始
//             wuyiStart: false,//五一节活动是否开始 默认未开始
//         };
//
//         this.unLock = this.unLock.bind(this);
//         this.getImgsFun = this.getImgsFun.bind(this);
//         this.goRoute = this.goRoute.bind(this);
//     }
//
//     goRoute(url){
//         this.props.history.push(url)
//     }
//
//     componentDidMount() {
//         document.title = this.state.curTitle;
//         this.getData(136)
//         let currentNav = 137;//男频
//         if(commonTools.cnzzData.property == 2){
//             currentNav = 138;//女频
//         }
//         this.setState({
//             currentNav: currentNav
//         },()=>{
//             this.getData(this.state.currentNav);
//             this.getImgsFun();
//         });
//         this.tuijianData();
//         this.dailyData();
//         this.historyData();
//
//         let minTime = new Date("2019/04/05 00:00:00").getTime();
//         let maxTime = new Date("2019/04/15 00:00:00").getTime();
//         let curTime = new Date().getTime();
//         if((curTime >= minTime && curTime <= maxTime) || !!commonTools.searchPar().qingmingStart){
//             this.setState({
//                 qingmingStart: true
//             });
//         }
//
//         let minTime1 = new Date("2019/04/27 00:00:00").getTime();
//         let maxTime1 = new Date("2019/05/06 00:00:00").getTime();
//         if((curTime >= minTime1 && curTime <= maxTime1) || !!commonTools.searchPar().wuyiStart){
//             this.setState({
//                 wuyiStart: true
//             });
//         }
//
//         let minTime2 = new Date("2019/06/05 00:00:00").getTime();
//         let maxTime2 = new Date("2019/06/17 00:00:00").getTime();
//         if((curTime >= minTime2 && curTime <= maxTime2) || !!commonTools.searchPar().duanwuStart){
//             this.setState({
//                 duanwuStart: true
//             });
//         }
//     }
//
//     getImgsFun(){
//         util.ajax({
//             url: "/zh/active/lists",
//             data:{
//               wechat_id:util.wechat_id,//以后封装到ajax里面
//             },
//             callback: res => {
//                 if (res.result.status.code == 0) {
//                     let json = res.result.data;
//                     this.setState({imgs: json})
//                 }
//             }
//         });
//     }
//
//     getData(type){
//         util.ajax({
//             url: "/zh/book/ranking",
//             isUser: true,
//             isWechatId: true,
//             data: {
//                 num: 10,
//                 page:1,
//                 re_cid:type
//             },
//             callback: res => {
//                 if (res.result.status.code == 0) {
//                     let json = res.result.data;
//                     let tempObj = {};
//                     switch (type){
//                         case 136:
//                             tempObj.data1 = json;
//                             break;
//                         default:
//                             tempObj.data2 = json;
//                     }
//                     this.setState(tempObj)
//                 }
//             }
//         });
//     }
//     // 阅文推荐
//     tuijianData(type){
//         util.ajax({
//             url: "/zh/book/yuewenlists",
//             data: {
//                 num: 4,
//                 page:1,
//                 yw_re_cid:136
//             },
//             callback: res => {
//                 if (res.result.status.code == 0) {
//                     let json = res.result.data;
//                     let tempObj = {};
//                     tempObj.data3 = json;
//                     this.setState(tempObj)
//                 }
//             }
//         });
//     }
//
//     // 每日全本购
//     dailyData(type){
//         util.ajax({
//             url: "/zh/allbookbuy/lists",
//             data: {
//                 num: 4,
//                 page:1,
//             },
//             callback: res => {
//                 if (res.result.status.code == 0) {
//                     let json = res.result.data;
//                     let tempObj = {};
//                     tempObj.dailyBook = json;
//                     this.setState(tempObj)
//                 }
//             }
//         });
//     }
//
//     changeData(index){
//         this.setState({
//             currentNav: index
//         },()=>{
//             this.getData(index)
//         })
//     }
//
//     historyData(){
//         util.ajax({
//             url:"/zh/user/lastRead",
//             isUser: true,
//             callback: res => {
//                 if (res.result.status.code == 0) {
//                     let data = res.result.data
//                     if(data.length > 0){
//                         this.setState({
//                             historyData: data[0]
//                         })
//                     }
//                 }
//             }
//         });
//     }
//
//     LinkTo(link){
//         this.props.history.push(`${link}`)
//     }
//
//     unLock(props,bookId,lockContentId){
//         util.ajax({
//             url: "/zh/additional/randomstr",
//             isUser: true,
//             isWechatId: true,
//             method: "post",
//             callback: res => {
//                 if (res.result.status.code == 0) {
//                     let random_str = res.result.data.random_str;
//                     document.location.href = `https://m.weidaoip.com/youhe/book/content/${bookId}/${lockContentId}?source=${document.location.host}&user_token=${util.user_token}&random_str=${random_str}`;
//                 }
//             }
//         });
//     }
//
//     render() {
//         return (
//             <div className='home' data-home="2">
//                 {
//                     this.state.imgs.length > 0 &&
//                     <div className='bannerBox'>
//                         <WingBlank>
//                             <Carousel
//                                 selectedIndex={0}
//                                 dots={false}
//                                 autoplay={true}
//                                 autoplayInterval={2000}
//                                 infinite={true}
//                             >
//                             {
//                                 this.state.imgs.map((item,index) => (
//                                     <img className={`imgBlock`} onClick={()=>this.goRoute(item.active_url)} src={item.active_img_url} key={`bannerimg${index}`} />
//                                 ))
//                             }
//                             </Carousel>
//                         </WingBlank>
//                     </div>
//                 }
//                 <div className='home_series'>
//                     <Link to='search' className='home_series_single a_s'>搜索</Link>
//                     <Link to='mine' className='home_series_single a_g'>个人中心</Link>
//                     <Link to='recharge' className='home_series_single a_c'>充值</Link>
//                     <Link to='recentlyread' className='home_series_single a_y'>阅读历史</Link>
//                 </div>
//                 {
//                     !!this.state.qingmingStart &&
//                     <Link to='/qingmingrecharge'><img className="czhd" src={require("../../../common/images/qingming1Bg.jpg")} /></Link>
//                 }
//                 {
//                     !!this.state.wuyiStart &&
//                     <Link to='/wuyirecharge'><img className="czhd" src={require("../../../common/images/wuyi1Bg.jpg")} /></Link>
//                 }
//                 {
//                     !!this.state.duanwuStart &&
//                     <Link to='/duanwurecharge'><img className="czhd" src={require("../../../common/images/duanwuBg1.jpg")} /></Link>
//                 }
//
//                 <div className='home_classifyRank'>
//                     <Link to='category' className='home_classifyRank_single'></Link>
//                     <Link to='rank' className='home_classifyRank_single'></Link>
//                 </div>
//
//                 {
//                     !!this.state.data1 && this.state.data1.length>0&&
//                     <div className='booksThr'>
//                         {
//                             this.state.data1.map((item,index) => (
//                                 <div className='booksThr_single' key={`a_${index}`} onClick={()=>goRoute(this.props,item.book_id,0)}>
//                                     <Img className='booksThr_single_pic' src={item.cover_url}/>
//                                     <div className='booksThr_single_name text-overflow'>{item.book_title}</div>
//                                     <div className='booksThr_single_author text-overflow'>{item.author_name}</div>
//                                 </div>
//                             ))
//                         }
//                     </div>
//                 }
//                 <div style={{marginTop:"0.3rem"}}></div>
//                 {
//                     isTest ? (
//                         <div className='module1'>
//                             <div className='title'>
//                                 <div className='title_line'></div>
//                                 <span className='title_font'>每日全本购</span>
//                             </div>
//                             {
//                                 (!!this.state.dailyBook && this.state.dailyBook.length>0) ?
//                                     <div className='booksThr'>
//                                         {
//                                             this.state.dailyBook.map((item,index) => (
//                                                 <div className='booksThr_single' key={`a_${index}`} onClick={()=>goRoute(this.props,item.book_id,0)}>
//                                                     <Img className='booksThr_single_pic' src={item.cover_url}/>
//                                                     <div className='booksThr_single_name text-overflow'>{item.book_title}</div>
//                                                     <div className='booksThr_single_author text-overflow' style={{position:"relative"}}>
//                                                         <span style={{color:"red",fontSize:"0.28rem",lineHeight:"0.28rem"}}>{item.discount_price}</span>
//                                                         <span style={{color:"red",fontSize:"0.14rem"}}>金币</span>
//                                                         <span style={{
//                                                             //贯穿线不居中
//                                                             position:"absolute",
//                                                             right:"0rem",
//                                                             top:"-0.02rem",
//                                                             display: "inline-block",
//                                                             color: "#666",
//                                                             fontSize: ".14rem",
//                                                             backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAJEAAAAAAP///5mZmf///yH5BAEAAAMALAAAAAABAAEAAAICVAEAOw==)",
//                                                             backgroundRepeat: "repeat-x",
//                                                             backgroundPosition: "left center",
//                                                             height:" .32rem",
//                                                             lineHeight: ".32rem",
//                                                         }}>
//                                                             {item.original_price}金币
//                                                         </span>
//                                                     </div>
//                                                 </div>
//                                             ))
//                                         }
//                                     </div> : ""
//                             }
//                         </div>
//                     ) : null
//                 }
//                 <div className='module1'>
//                     <div className='title'>
//                         <div className='title_line'></div>
//                         <span className='title_font'>阅文推荐</span>
//                     </div>
//
//                     {
//                         !!this.state.data3 && this.state.data3.length>0&&
//                         <div className='bookOne clearfix' onClick={()=>this.unLock(this.props,this.state.data3[0].book_id,0)}>
//                             <Img className='booksThr_single_pic' src={this.state.data3[0].img_url}/>
//                             <div className='booksThr_single_name text-overflow'>{this.state.data3[0].book_name}</div>
//                             <div className='booksThr_single_author text-overflow3'>{this.state.data3[0].book_intro}</div>
//                         </div>
//                     }
//                     {
//                         !!this.state.data3 && this.state.data3.length>0&&
//                         <div className='booksThr'>
//                             {
//                                 this.state.data3.map((item,index) => (
//                                     !!index && <div className='booksThr_single' key={`a_${index}`} onClick={()=>this.unLock(this.props,item.book_id,0)}>
//                                         <Img className='booksThr_single_pic' src={item.img_url}/>
//                                         <div className='booksThr_single_name text-overflow'>{item.book_name}</div>
//                                         <div className='booksThr_single_author text-overflow'>{item.author_name}</div>
//                                     </div>
//                                 ))
//                             }
//                         </div>
//                     }
//                 </div>
//
//                 <div className='module1'>
//                     <div className='title'>
//                         <div className='title_line'></div>
//                         <span className='title_font'>排行</span>
//                     </div>
//                     <div className='tab'>
//                         <div className={`tab_single ${this.state.currentNav==138 && 'tab_singleColor'}`} onClick={()=>this.changeData(138)}>女生</div>
//                         <div className={`tab_single ${this.state.currentNav==137 && 'tab_singleColor'}`} onClick={()=>this.changeData(137)}>男生</div>
//                         {/* <div className={`tab_single ${this.state.currentNav==139 && 'tab_singleColor'}`} onClick={()=>this.changeData(139)}>出版</div> */}
//                     </div>
//                     <div className='books1'>
//                         <div className='books1_singleOut'>
//                             {
//                                 !!this.state.data2 && this.state.data2.length>0 &&
//                                     this.state.data2.map((item,index) => (
//                                         index < 3 &&
//                                         <div className='books1_single' key={`b_${index}`} onClick={()=>goRoute(this.props,item.book_id,0,0)}>
//                                             <Img className='books1_single_pic' src={item.cover_url}/>
//                                             <div className='books1_single_name text-overflow'>{item.book_title}</div>
//                                             <div className='books1_single_author text-overflow'>{item.author_name}</div>
//                                             <div className='books1_single_rank'>{parseInt(index)+1}</div>
//                                         </div>
//                                     ))
//                             }
//                         </div>
//                         <div className='books1_singleNextOut'>
//                             {
//                                 !!this.state.data2 && this.state.data2.length>0 &&
//                                     this.state.data2.map((item,index) => (
//                                         index>2 &&
//                                         <div className='books1_singleNext' key={`c_${index}`} onClick={()=>goRoute(this.props,item.book_id,0,0)}>
//                                             <span className='books1_singleNext_rank'>{index+1}.</span>
//                                             <span className='books1_singleNext_type'>{!!item.category_info.category_1.short_name?item.category_info.category_1.short_name:"其他"}</span>
//                                             <span className='books1_singleNext_name text-overflow'>{item.book_title}</span>
//                                             <span className='books1_singleNext_author text-overflow'>{item.author_name}</span>
//                                         </div>
//                                     ))
//                             }
//                       </div>
//                     </div>
//                 </div>
//                 <Link to={`/rank?type=${this.state.currentNav}`} className='more'>更多</Link>
//                 {
//                     !!this.state.historyData && this.state.historyData.book_id &&
//                         <div className='lastTime' onClick={()=>goRoute(this.props,this.state.historyData.book_id,this.state.historyData.content_id,0)}>
//                             <Img className='book' src={require('../../../common/images/book.png')} alt=""/>
//                             <span className='font text-overflow'>请继续阅读《{this.state.historyData.book_title.length>6?this.state.historyData.book_title.substring(0,6)+'...':this.state.historyData.book_title}》，点击继续</span>
//                             <Img className='arrow' src={require('../../../common/images/arrow_r.png')} alt=""/>
//                         </div>
//                 }
//             </div>
//         );
//     }
// }